module.exports = __webpack_public_path__ + "static/img/239_TO8_2166_og.6a14400.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/239_TO8_2166_og.jpg
// module id = 6tyW
// module chunks = 0